// extracted by mini-css-extract-plugin
export default {"container":"RegisterWhatsAppNumber_container__Llocn","input":"RegisterWhatsAppNumber_input__rBtrF","button":"RegisterWhatsAppNumber_button__mfufO"};